<div style="padding: 10px" [innerHTML]="message | keepHtml">
</div>
@if (details != "") {
  <details style="padding: 0 10px 10px">
    <summary style="cursor: pointer">{{detailsLabel}}</summary>
    <pre style="white-space: pre-wrap; overflow-wrap: anywhere">{{details}}</pre>
  </details>
}
<p-footer [style.display]="'flex'">
  @for (button of buttons; track button) {
    <button class="mr-1" type="button" pButton [icon]="button.icon" [label]="button.caption" (click)="click(button.id)" style="margin-right: 5px; margin-top: 10px"></button>
  }
</p-footer>
